import { Color } from '@tmh-website/shared/colors';

export type EnvironmentSelectButtonBorderThemeColor = Color.Blue_600;

export interface EnvironmentSelectButtonBorderTheme {
  normal: Color;
  hover: Color;
  active: Color;
}

export const environmentSelectButtonBordeThemes: {
  [key in EnvironmentSelectButtonBorderThemeColor]: EnvironmentSelectButtonBorderTheme;
} = {
  [Color.Blue_600]: {
    normal: Color.Blue_600,
    hover: Color.Blue_700,
    active: Color.Blue_800,
  },
};
